import React from 'react';
import BulkImportUDIs, { BulkImportUDIsIntro } from "../Products/BulkImportUDIs.js";
import { getUdiRegionByEntityType } from "./UdiRegions.js";


const AddItemPopup = ({ globalContext }) => {

    const AppContext = globalContext;
    const region = getUdiRegionByEntityType(AppContext.entityType);

    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Add {AppContext.singleItemTitle}s</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>


            <div
                style={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "row",
                    marginBottom: "15px",
                    marginTop: "10px"
                }}>

                <div
                    style={{
                        paddingBottom: "3px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                        borderBottom: "2px solid #00abff"
                    }}
                >
                    <i className="fas fa-file-alt g-mr-5"></i> Bulk UDI Upload
                </div>

                <div style={{ flex: 1, borderBottom: "2px solid #f0f0f0" }}></div>

            </div>


            <div style={{ marginTop: "20px" }}>
                <div style={{ paddingTop: "10px", textAlign: "center", paddingBottom: "30px" }}>
                    <BulkImportUDIsIntro />

                    <BulkImportUDIs defaultUdiType={region?.value ?? ""} onUploaded={() => AppContext.refreshData()} />
                </div>
            </div>

        </div>
    );
};


export default AddItemPopup;
